import { MultiValue, ZCDSelect } from '@zencity/common-ui';
import React, { ReactElement, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldTitle } from 'screens/WidgetGenerator/components/FieldTitle/FieldTitle';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { ReportFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { fetchAspectsByParams } from 'services/aspect';
import { logger } from 'utils/logger';

export const ReportAspectsFilter = (props: ReportFilterProps<string[]>): ReactElement => {
  const { onChange, filterValues } = props;
  const { selectedSurveyGroup } = useContext(WidgetGeneratorContext);
  const [aspectOptions, setAspectOptions] = React.useState<{ value: string; label: string }[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const { t: translate } = useTranslation();

  useEffect(() => {
    const getAspects = async () => {
      setLoading(true);
      try {
        const { results: fetchedAspects } = await fetchAspectsByParams({ survey_group: selectedSurveyGroup.id });
        const aspectsOptions = fetchedAspects.map((aspect) => ({
          value: aspect.value,
          label: aspect.label,
        }));
        setAspectOptions(aspectsOptions);
      } catch (error) {
        logger.warn(error);
      } finally {
        setLoading(false);
      }
    };

    getAspects();
  }, [selectedSurveyGroup.id]);

  const aspectsFromFilter =
    filterValues?.selectedServiceBarAspects && Array.isArray(filterValues?.selectedServiceBarAspects)
      ? filterValues?.selectedServiceBarAspects
      : [];

  const selectedAspectOptions = aspectsFromFilter.map((aspectValue) => ({
    value: aspectValue,
    label: aspectOptions.find((aspectOption) => aspectOption.value === aspectValue)?.label,
  }));

  const handleOnAspectSelect = (newValue: MultiValue<{ value: string; label: string | undefined }>) => {
    const newSelectedAspects = newValue.map((aspect) => aspect.value);
    onChange(newSelectedAspects);
  };

  return (
    <>
      <FieldTitle title={translate('widgetGenerator.filters.servicesBarChart.selectAspects')} />
      <ZCDSelect
        isLoading={loading}
        isDisabled={loading}
        isClearable
        isMulti
        options={aspectOptions}
        value={selectedAspectOptions}
        onChange={handleOnAspectSelect}
      />
    </>
  );
};
